import { useEffect } from 'react';

import { hasLoggedInCookie } from '@helsenorge/framework-utils/cookie';
import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';
import { erTjenester } from '@helsenorge/framework-utils/hn-proxy-service';
import type { WebCompProps } from '@helsenorge/framework-utils/web-component/register';

import { Broker } from '../broker';
import { createCrossDomainIFrame } from './session-utils';
import WarningLightbox from './warning-lightbox';
interface Props {
  isauthorized?: string;
  lightboxinactivitytitle?: string;
  lightboxinactivitydescription?: string;
  lightboxinactivitytimer?: string;
  lightboxinactivitydoyouwanttostay?: string;
  lightboxinactivitybuttonyes?: string;
  lightboxinactivitybuttonsignout?: string;
  inactivitysignedouttitle?: string;
  inactivitysignedoutbuttongotoroot?: string;
  inactivitysignedoutbuttonsigninagain?: string;
  representasjonmodaltitle?: string;
  representasjonmodaldescription?: string;
  representasjonmodalknapp?: string;
  representasjonmodalfeilmelding?: string;
  representasjonmodalfeilmeldingdescription?: string;
}

const Session: React.FC<Props & WebCompProps> = props => {
  const authorized = isAuthorized() || hasLoggedInCookie();
  useEffect(() => {
    if (!erTjenester() && authorized) {
      createCrossDomainIFrame();
    }
  }, [authorized]);
  return (
    <>
      <Broker
        representasjonModalTitle={props.representasjonmodaltitle}
        representasjonModalDescription={props.representasjonmodaldescription}
        representasjonModalKnapp={props.representasjonmodalknapp}
        representasjonModalFeilmelding={props.representasjonmodalfeilmelding}
        representasjonModalFeilmeldingDescription={props.representasjonmodalfeilmeldingdescription}
        authorized={authorized}
      />
      <WarningLightbox
        authorized={authorized}
        resources={{
          lightboxInactivityTitle: props.lightboxinactivitytitle,
          lightboxInactivityDescription: props.lightboxinactivitydescription,
          lightboxInactivityTimer: props.lightboxinactivitytimer,
          lightboxInactivityDoYouWantToStay: props.lightboxinactivitydoyouwanttostay,
          lightboxInactivityButtonYes: props.lightboxinactivitybuttonyes,
          lightboxInactivityButtonSignOut: props.lightboxinactivitybuttonsignout,
          inactivitySignedOutTitle: props.inactivitysignedouttitle,
          inactivitySignedOutButtonGoToRoot: props.inactivitysignedoutbuttongotoroot,
          inactivitySignedOutButtonSignInAgain: props.inactivitysignedoutbuttonsigninagain,
        }}
      />
    </>
  );
};

export default Session;
